//import React from 'react';

// Constants.
import { INSTANCE_TYPE_CONFIG } from '../../component/Constants';

// Types.
import Instance from '../../types/instance/InstanceTarget';

// Helpers.
import Helper from '../../helpers/Helper';

function InstanceType(props: { instance: Instance }) {

    const tooltip = Helper.getInstanceType(props.instance);

    // Get config from map, with fallback for unknown types
    const config = INSTANCE_TYPE_CONFIG[props.instance.type];
    
    let iconClassName = config?.iconClass || 'icon icon-database';
    const iconColor = config?.iconColor || '';

    // Special case for MariaDB (variant of MySQL)
    if (props.instance.type === 'mysql' && props.instance.version?.toLowerCase().includes('mariadb')) {
        iconClassName = 'icon icon-mariadb';
    }

    return (
        <span className="float-center" data-tip={tooltip}>
            <i className={iconClassName} style={{color: iconColor}}>
            </i>
        </span>
    );
}

export default InstanceType;
